import types from "../config/types";

const getCategoriesArr = (cartProducts, applicationType) => {

  if (cartProducts.length === 0) {
    return [];
  }

  if (applicationType === "normal") {
    return cartProducts.map((item) => item?.product?.categories?.[0]?.name);
  }

  return cartProducts.map((item) => item?.product?.categories?.[1]?.name);
};

const getQuantityArr = (cartProducts) => {

  if (cartProducts.length > 0) {
    return cartProducts.map((item) => item?.quantity);
  }

  return [];
};

function getDealFormattedPrice(item) {
  return `${item?.product?.monthly_recurring} x ${item?.product?.payment_terms_label}`;
}

const getPriceArr = (cartProducts, applicationType) => {

  if (cartProducts.length === 0) {
    return [];
  }

  if (applicationType === "normal") {
    return cartProducts.map((item) => item?.prices?.row_total_original?.value);
  }

  return cartProducts.map((item) => getDealFormattedPrice(item));
};

const getProductSkuArr = (cartProducts) => {

  if (cartProducts.length > 0) {
    return cartProducts.map((item) => item?.product?.sku);
  }

  return [];
};

const getProductNameArr = (cartProducts) => {

  if (cartProducts.length > 0) {
    return cartProducts.map((item) => item?.product?.name);
  }

  return [];
};

const isPreOrder = (cartProducts) => {

  let preOrderFound = cartProducts.filter(
    (item) =>
      item?.product?.badges_label &&
      item?.product?.badges_label
        .toLowerCase()
        .indexOf(types.TYPE_PREORDER.toLowerCase()) > -1
  );

  return preOrderFound && preOrderFound.length > 0;
};

export class MiniAppUtagUtil {

  static getSalesAnalyticsData(cartProducts, applicationType) {

    const salesAnalyticsData = {
      sales_product_category: getCategoriesArr(cartProducts, applicationType),
      sales_product_id: getProductNameArr(cartProducts),
      sales_product_name: getProductSkuArr(cartProducts),
      sales_product_price: getPriceArr(cartProducts, applicationType),
      sales_product_quantity: getQuantityArr(cartProducts),
      preorder_sales_event: isPreOrder(cartProducts) ? "cbu_pre_order" : "",
    };

    salesAnalyticsData.multicart_flag = false; // TODO: add logic when multicart gets implemented

    return salesAnalyticsData;
  }
}